import { ApiMananger } from "actions/rtkquery";
import { PIECES_COMPTABLES_API_ROUTE } from "routes/api/endpoints";
import { INVALIDATE_PIECES } from "./queries";

const piecesMutations = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    createPieceComptable: build.mutation({
      query: (formData) => ({
        url: PIECES_COMPTABLES_API_ROUTE,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [INVALIDATE_PIECES],
    }),

    updatePieceComptable: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [INVALIDATE_PIECES],
    }),

    deletePieceComptable: build.mutation({
      query: ({ id }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [INVALIDATE_PIECES],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreatePieceComptableMutation,
  useUpdatePieceComptableMutation,
  useDeletePieceComptableMutation,
} = piecesMutations;
